module.exports = __webpack_public_path__ + "static/img/larval-master.869446c.svg";